import type { RouteObject } from 'react-router';

import { AppShell } from '@/components/layout/AppShell';
import { RouteFallback } from '@/components/layout/RouteFallback';
import { RouteError } from '@/components/RouteError';
import { HomePage } from '@/pages/HomePage';

/**
 * Every route except the home page is code-split, so a first visit downloads
 * the shell plus one page rather than the whole site. `errorElement` is set per
 * child route so a failing page renders inside the shell, leaving the header,
 * navigation and footer usable.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    errorElement: <RouteError />,
    hydrateFallbackElement: <RouteFallback />,
    children: [
      { index: true, element: <HomePage />, errorElement: <RouteError /> },
      {
        path: 'about',
        errorElement: <RouteError />,
        lazy: async () => ({ Component: (await import('@/pages/AboutPage')).AboutPage }),
      },
      {
        path: 'experience',
        errorElement: <RouteError />,
        lazy: async () => ({ Component: (await import('@/pages/ExperiencePage')).ExperiencePage }),
      },
      {
        path: 'case-studies',
        errorElement: <RouteError />,
        lazy: async () => ({
          Component: (await import('@/pages/CaseStudiesPage')).CaseStudiesPage,
        }),
      },
      {
        path: 'case-studies/:slug',
        errorElement: <RouteError />,
        lazy: async () => ({
          Component: (await import('@/pages/CaseStudyDetailPage')).CaseStudyDetailPage,
        }),
      },
      {
        path: 'contact',
        errorElement: <RouteError />,
        lazy: async () => ({ Component: (await import('@/pages/ContactPage')).ContactPage }),
      },
      {
        path: 'cv',
        errorElement: <RouteError />,
        lazy: async () => ({ Component: (await import('@/pages/CvPage')).CvPage }),
      },
      {
        path: 'privacy',
        errorElement: <RouteError />,
        lazy: async () => ({ Component: (await import('@/pages/PrivacyPage')).PrivacyPage }),
      },
      {
        path: '*',
        errorElement: <RouteError />,
        lazy: async () => ({ Component: (await import('@/pages/NotFoundPage')).NotFoundPage }),
      },
    ],
  },
];
